// src/apis/pda1090Api.ts

import config from "../../../config";
import { ResponseDto } from "../../../dtos/common/responseDto";
import { 
  PDA1090_R01Dto, 
  PDA1090_R01UpdateRequest 
} from "./PDA1090_R01Dto";
import { getData, putData } from "../../../utils/axios/serverHelper";

const baseUrl = `${config.apiUrl}/PDA1090_R01`;

// ========== PDA1090_R01 재고실사 등록 API ==========

/**
 * LOT 스캔 - 재고 현황 조회
 * 
 * LOT 번호로 품목 정보 및 창고별 재고 현황을 조회합니다.
 * 
 * @param lotNo LOT 번호
 * @returns 품목 정보 및 창고별 재고 현황
 */
export const getPDA1090_R01 = async (lotNo: string) => {
  const url = `${baseUrl}/${lotNo}`;
  return await getData<ResponseDto<PDA1090_R01Dto>>(url);
};

/**
 * 재고 조정 실행
 * 
 * 재고실사 결과를 반영하여 시스템 재고를 조정합니다.
 * - wms_stock 업데이트
 * - wms_transport 생성 (수불 이력)
 * 
 * @param request 재고 조정 요청 데이터
 * @returns 조정 결과 (전표번호, 차이수량 등)
 */
export const updatePDA1090_R01 = async (request: PDA1090_R01UpdateRequest) => {
  return await putData<PDA1090_R01UpdateRequest, ResponseDto<PDA1090_R01Dto>>(
    baseUrl, 
    request
  );
};
